export const SET_FEATURE_FLAGS = "SET_FEATURE_FLAGS";

export function setFeatureFlags(featureFlags) {
  return {
    type: SET_FEATURE_FLAGS,
    payload: featureFlags,
  };
}
